import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow",
        destructive: "bg-destructive text-destructive-foreground shadow-sm",
        outline: "border border-input bg-background shadow-sm",
        "pill-ghost":
          "rounded-full text-primary border border-primary disabled:border-neutral-300 disabled:text-neutral-400 disabled",
        secondary:
          "bg-gray-100 text-gray-700 hover:bg-gray-100 shadow-sm focus-visible:ring-0 focus-visible:ring-offset-0",
        ghost: "hover:bg-transparent",
        toolbar:
          "bg-transparent text-gray-600 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-200 transition-all duration-150 focus-visible:ring-0 focus-visible:ring-offset-0",
        "toolbar-white":
          "bg-white text-gray-600 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-100 transition-all duration-150 focus-visible:ring-0 focus-visible:ring-offset-0",
        link: "text-primary underline-offset-4",
        icon: "bg-transparent text-primary hover:bg-primary/5",
        counter:
          "h-8 w-8 rounded-full border border-primary text-primary transition-colors hover:bg-primary/5 disabled:text-neutral-400 disabled:border-neutral-300 disabled:hover:bg-white",
        "toolbar-action":
          "h-8 w-8 bg-transparent text-gray-600 hover:bg-gray-100 transition-colors duration-150 focus-visible:ring-0 focus-visible:ring-offset-0",
        navbar: "bg-white text-gray-600 hover:bg-gray-100",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-4 text-xs",
        md: "text-[15px]",
        lg: "h-10 px-8",
        icon: "h-9 w-9",
        "toolbar-icon":
          "h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center [&_svg]:size-4 sm:[&_svg]:size-5",
        "toolbar-action": "h-8 w-8 [&_svg]:size-4",
        navbar: "",
        iconLg: "h-14 w-14 [&_svg]:size-10",
      },
      fullWidth: {
        true: "w-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      fullWidth: false,
    },
  }
);
